import { EonUiDropdown, EonUiDropdownOption } from "@eon-ui/eon-ui-components-react";
import { useMemo } from "react";

const OnboardingPortalOwnerFilter = ({
    t,
    owner,
    setOwner,
    list,
}: {
    t: (key: string) => string;
    owner: string;
    setOwner: (owner: string) => void;
    list: any[];
}) => {
    const ownerCounts = useMemo(() => {
        const counts = new Map<string, number>();
        list.forEach((item) => {
            const ownerName =
                typeof item.owner === "string" ? item.owner.trim() : "";
            if (!ownerName) {
                return;
            }
            counts.set(ownerName, (counts.get(ownerName) || 0) + 1);
        });
        return Array.from(counts.entries()).sort(([a], [b]) =>
            a.localeCompare(b, undefined, { sensitivity: "base" })
        );
    }, [list]);
    return (
        <EonUiDropdown
            label={t("onboardingPortal.tableHeaders.owner")}
            size="small"
            value={owner}
            onValueChanged={(e) => setOwner(e.target.value)}
            key={owner}
            height={"300px"}
            style={{ minWidth: "200px", width: "auto", maxWidth: "100%" }}
        >
            <EonUiDropdownOption
                key={"all"}
                value={""}
                label={t("onboardingPortal.tableHeaders.selectAll")}
            />
            {ownerCounts.map(([ownerName, count]) => (
                <EonUiDropdownOption
                    key={ownerName}
                    value={ownerName}
                    label={`${ownerName} (${count})`}
                />
            ))}
        </EonUiDropdown>
    );
};

export default OnboardingPortalOwnerFilter;